import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

export interface FamilyStudent {
  _id: string;
  firstName: string;
  lastName: string;
  dob: string;
  name: string;
}

export const getFamilyStudents = async (
  parentId: string,
): Promise<FamilyStudent[]> => {
  const response = await baseAPI.get<FamilyStudent[]>(
    `/students/family/${parentId}`,
  );

  return response.data;
};

export const useGetFamilyStudents = (parentId: string) => {
  return useQuery({
    queryKey: [...QUERY_KEYS.STUDENTS, 'family', parentId],
    queryFn: () => getFamilyStudents(parentId),
    enabled: !!parentId,
  });
};

